/**
 * Keep absolute media URLs intact and recover legacy URLs where an absolute
 * URL was accidentally passed through Storage::publicUrl as if it were a path.
 */
export function normalizeMediaUrl(value) {
  if (!value || typeof value !== "string") return null;

  const raw = value.trim();
  const nestedAbsoluteIndex = raw.slice(8).search(/https?:\/\//i);
  if (nestedAbsoluteIndex >= 0) {
    return raw.slice(nestedAbsoluteIndex + 8);
  }

  const encodedAbsolute = raw.match(/https?%3A(?:%2F|\/)/i);
  if (encodedAbsolute?.index > 0) {
    try {
      return decodeURIComponent(raw.slice(encodedAbsolute.index)).replace(
        /^(https?):\/(?!\/)/i,
        "$1://"
      );
    } catch {
      return raw;
    }
  }

  return raw;
}
